import {JournalEntry} from "../DB/journalEntries/@JournalEntry";
import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";

const MTClass = JournalEntry;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddJournalEntry extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateJournalEntry extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteJournalEntry extends Command<{id: string}> {}